import React from "react";
import {
  Layout,
  Typography,
  Row,
  Col,
  Button,
  Card,
  Divider,
  Breadcrumb,
  Image,
  Carousel,
} from "antd";
import { NavLink } from "react-router-dom";
import img99 from "../../assets/99.jpg";
import img1 from "../../assets/dig-1.png";
import img2 from "../../assets/dig-2.png";
import img3 from "../../assets/dig-3.png";

import { ArrowLeftOutlined } from "@ant-design/icons";
import s from "./styles.module.css";
import { Fade } from "react-awesome-reveal";
import { SendButton } from "../../components/SendButton";

const { Header, Content } = Layout;
const { Title, Paragraph } = Typography;

export const DigitalSolutions = () => {
  return (
    <Layout>
      <Row
        style={{
          position: "absolute",
          maxWidth: "1440px",
          top: "80px",
          margin: "0 auto",
          padding: "0 20px",
          zIndex: 100,
          right: 0,
          left: 0,
        }}
      >
        <Col>
          <Title className={s["digital-solutions-title"]}>
            Digital Solutions
          </Title>
          <Breadcrumb
            items={[
              {
                title: (
                  <NavLink to={"/"}>
                    <ArrowLeftOutlined style={{ marginRight: "5px" }} />
                    Back to main
                  </NavLink>
                ),
              },
            ]}
          />
        </Col>
      </Row>
      <Carousel effect={"fade"}>
        <div className={s["main-carusel-wrapper"]}>
          <img src={img99} className="responsive-image" alt="Digital" />
          <Content
            style={{ padding: "24px", maxWidth: "1440px", margin: "0 auto" }}
          >
            <Row className={s["main-carusel-row"]}>
              <Col xs={24} md={12} style={{ zIndex: 2 }}>
                <div className={s["main-carusel-title"]}>
                  Transforming Data into Actionable Insights
                </div>
                <Paragraph className={s["main-carusel-description"]}>
                  Modern business moves at unfathomable speeds - that’s why
                  efficient and intelligent use of data is crucial to staying
                  ahead of the competition. Our Digital Solutions service
                  empowers organizations with customized, automated tools to
                  streamline processes, enhance decision-making, and drive
                  performance.
                </Paragraph>
                <Paragraph className={s["main-carusel-description"]}>
                  How do we set your business up for adaptive success? We have
                  the knowledge and tools to keep your company ahead of today’s
                  lightning business movement.
                </Paragraph>
              </Col>
            </Row>
          </Content>
        </div>
      </Carousel>
      <Divider />
      <Content
        style={{ padding: "24px", maxWidth: "1440px", margin: "0 auto" }}
      >
        <Fade cascade triggerOnce damping={0.1}>
          <Row gutter={[16, 16]}>
            <Col xs={24} md={24}>
              <Card className={s["digital-solutions-card"]}>
                <Image src={img1} preview={false} />
                <Title level={3}>
                  Tailored Automation for Your Unique Business Needs
                </Title>
                <Paragraph>
                  Our team of experts specializes in creating bespoke digital
                  products that fully align with your company’s objectives.
                  Whether you need to automate workflows in MS Excel or require
                  advanced Power BI analytical dashboards, we develop solutions
                  that integrate seamlessly into your existing systems.
                  Automating repetitive processes and standardizing data
                  management, we help you reduce manual effort, minimize errors,
                  and boost productivity.
                </Paragraph>
              </Card>
            </Col>
          </Row>
          <Divider />
          <Row gutter={[16, 16]}>
            <Col xs={24} md={12}>
              <Card className={s["digital-solutions-card"]}>
                <Image src={img2} preview={false} />

                <Title level={3}>
                  Data Analytics: Unlocking the Power of Information
                </Title>
                <Paragraph>
                  You must have the right tools to interpret and visualize
                  information in a data-driven world. Our Power BI solutions
                  provide comprehensive analytics and interactive dashboards
                  that allow you to see the bigger picture while drilling into
                  specifics. From financial performance tracking to operational
                  efficiency metrics, our customized reporting solutions give
                  you insights to help you make informed, timely decisions. We
                  ensure your data is presented in a clear, actionable format,
                  empowering your teams to analyze trends, monitor key
                  performance indicators (KPIs), and accurately forecast.
                </Paragraph>
              </Card>
            </Col>
            <Col xs={24} md={12}>
              <Card className={s["digital-solutions-card"]}>
                <Image src={img3} preview={false} />

                <Title level={3}>
                  Seamless Integration and Ongoing Support
                </Title>
                <Paragraph>
                  We don’t just build digital tools—we build partnerships. Our
                  experts work closely with your team to ensure our solutions
                  seamlessly integrate into your daily operations. And we offer
                  continuous support and updates, ensuring that your digital
                  infrastructure evolves alongside your business needs.
                </Paragraph>
              </Card>
            </Col>
          </Row>
          <Divider />
          <Row justify="center" className={s["digital-solutions-footer"]}>
            <Col>
              <Paragraph>
                Let us help you unlock the full potential of your data with our
                cutting-edge Digital Solutions. Get in touch with our
                experienced consulting team specializing in creating customized
                platforms that get the best out of your business. Finally, you
                can have the utmost confidence in your decision making.
              </Paragraph>
              <SendButton
                type="primary"
                size="large"
                className={s["digital-solutions-button"]}
              >
                Get in Touch
              </SendButton>
            </Col>
          </Row>
        </Fade>
      </Content>
    </Layout>
  );
};
